import {
  LOCATIONSFORPOSTINGS_GET_REQUEST,
  LOCATIONSFORPOSTINGS_GET_SUCCESS,
  LOCATIONSFORPOSTINGS_GET_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import { selectSelectedDate, selectSelectedTeam } from '../../../reducers/areas/dailyPlanning/selectors';

function getLocationsForPostings(forceUpdate) {
  return {
    types: [LOCATIONSFORPOSTINGS_GET_REQUEST, LOCATIONSFORPOSTINGS_GET_SUCCESS, LOCATIONSFORPOSTINGS_GET_FAILURE],
    shouldCallAPI: forceUpdate ? () => true : () => true,
    buildCallParameters: state => ({
      method: HTTP_METHOD.GET,
      path: `v1/query/GetLocationsForPostings?date=${selectSelectedDate(state)}&teamIds=${selectSelectedTeam(state)}`,
    }),
  };
}

export { getLocationsForPostings };
